module.exports = __webpack_public_path__ + "static/v1.0.1.3/img/headImg.23ef0d96.png";